import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import Menu from '../menu';
import { withTranslation } from 'react-i18next';
import TextIcon from '../svg-icons/text-icon';
var FieldSetting = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldSetting, _React$Component);
  var _super = _createSuper(FieldSetting);
  function FieldSetting(props) {
    var _this;
    _classCallCheck(this, FieldSetting);
    _this = _super.call(this, props);
    _this.onMouseEnter = function () {
      if (!_this.props.option) return;
      var container = _this.settingRef;
      var _container$getBoundin = container.getBoundingClientRect(),
        height = _container$getBoundin.height,
        width = _container$getBoundin.width;
      var position = {
        height: height,
        width: width
      };
      _this.setState({
        isShowMenu: true,
        position: position
      });
    };
    _this.onMouseLeave = function () {
      _this.setState({
        isShowMenu: false
      });
    };
    _this.onBoldClick = function (event) {
      event.stopPropagation();
      var option = _this.props.option;
      var newOption = _objectSpread(_objectSpread({}, option), {}, {
        bold: !option.bold
      });
      _this.props.onUpdateOption(newOption);
    };
    _this.onItalicClick = function (event) {
      event.stopPropagation();
      var option = _this.props.option;
      var newOption = _objectSpread(_objectSpread({}, option), {}, {
        italic: !option.italic
      });
      _this.props.onUpdateOption(newOption);
    };
    _this.setSettingRef = function (ref) {
      _this.settingRef = ref;
    };
    _this.state = {
      isShowMenu: false,
      position: {
        top: 0,
        left: 0
      }
    };
    return _this;
  }
  _createClass(FieldSetting, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        option = _this$props.option,
        t = _this$props.t;
      var isDisable = !option;
      var _ref = option || {},
        isBold = _ref.bold,
        isItalic = _ref.italic;
      var isShowMenu = this.state.isShowMenu;
      var className = "field-setting ".concat(isDisable ? 'disable' : '', " option-item");
      return /*#__PURE__*/React.createElement("span", {
        ref: this.setSettingRef,
        className: className,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, /*#__PURE__*/React.createElement(TextIcon, {
        width: "14",
        color: '#aaa'
      }), /*#__PURE__*/React.createElement("span", {
        className: "label"
      }, t('Font_style')), /*#__PURE__*/React.createElement("span", {
        className: "icon-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "iconfont icon-caret-up op-icon"
      })), isShowMenu && /*#__PURE__*/React.createElement(Menu, {
        position: this.state.position
      }, /*#__PURE__*/React.createElement(Menu.Item, {
        iconClass: 'iconfont icon-bold',
        isChecked: isBold,
        onClick: this.onBoldClick
      }, t('bold')), /*#__PURE__*/React.createElement(Menu.Item, {
        iconClass: 'iconfont icon-italic',
        isChecked: isItalic,
        onClick: this.onItalicClick
      }, t('italic'))));
    }
  }]);
  return FieldSetting;
}(React.Component);
export default withTranslation('seafile-editor')(FieldSetting);